// v-decrypt — text "decrypts" into place: scrambled glyphs resolve left to right,
// in the style of the Decrypted/Hyper Text components on 21st.dev. Driven by Motion.
//   v-decrypt                      default timing
//   v-decrypt="{ delay: 0.6, duration: 1.4 }"
//   v-decrypt="{ after: '#loreView' }"   wait for that element's entrance animations
//                                        (CSS and Motion) to finish, then decrypt
// Skipped (text shown as-is) for viewers who prefer reduced motion.

import { animate } from "motion";

const GLYPHS = "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789#%&/<>[]=+*";
const scramble = () => GLYPHS[Math.floor(Math.random() * GLYPHS.length)];

export default {
	mounted(el, binding) {
		if (window.matchMedia?.("(prefers-reduced-motion: reduce)").matches) return;
		const { delay = 0.4, duration = 1.3, after = null } = binding.value || {};
		const text = el.textContent;
		// Hold the final width so the line doesn't jitter while glyphs change
		el.style.minWidth = `${el.getBoundingClientRect().width}px`;
		// Unrevealed characters are non-breaking spaces, which (unlike spaces) don't collapse
		const HIDDEN = "\u00a0";
		el.textContent = text.replace(/\S/g, HIDDEN);
		const run = startDelay =>
			(el._decrypt = animate(0, 1, {
				delay: startDelay,
				duration,
				ease: "linear",
				onUpdate: progress => {
					const revealed = Math.floor(progress * text.length);
					let out = "";
					for (let i = 0; i < text.length; i++) {
						const ch = text[i];
						if (i < revealed || ch === " ") out += ch;
						else if (i < revealed + 6) out += scramble();
						else out += HIDDEN;
					}
					el.textContent = out;
				},
				onComplete: () => {
					el.textContent = text;
					el.style.minWidth = "";
				},
			}));
		if (!after) return run(delay);
		// Give the page a moment to start its entrance, then wait for every finite
		// animation inside it (the panels sliding in, lists loading) to end
		el._decryptWait = setTimeout(async () => {
			const root = document.querySelector(after);
			const pending = root
				? root.getAnimations({ subtree: true }).filter(a => {
						const t = a.effect?.getComputedTiming?.();
						return t && Number.isFinite(t.endTime) && a !== el._decrypt;
				  })
				: [];
			await Promise.allSettled(pending.map(a => a.finished));
			if (el.isConnected) run(delay);
		}, 120);
	},
	beforeUnmount(el) {
		clearTimeout(el._decryptWait);
		el._decrypt?.stop();
	},
};
